<template>
  <section class="ls-additional-info" :class="themedClass">
    <span>
      <span v-if="label" class="ls-additional--info--label" test-id="label">{{ label }}</span>
      <a class="ls-additional--info--clickable-label" test-id="clickable_label" @click="onClick">{{
        clickableLabel
      }}</a>
    </span>
    <BCollapse :open.sync="open">
      <div class="ls-additional--info--content"><slot /></div>
    </BCollapse>
  </section>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsAdditionalInfo',
  mixins: [themedComponentMixin],
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    label: VueTypes.string,
    clickableLabel: VueTypes.string.def('Why are you asking this?'),
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    onClick() {
      lsTrackingService.track({ event: 'click', target: this.trackId });
      this.open = !this.open;
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-additional--info--label {
  padding-right: 5px;
  font-size: $size-6;
  font-weight: bold;
}

.ls-additional--info--clickable-label {
  font-size: $size-6;
  user-select: none;
}

.ls-additional--info--content {
  background-color: $primary-light;
  padding: 20px;
}

.ls-additional-info {
  &.themed-component {
    .ls-additional--info--label {
      font-size: var(--theme-txt-body-sm);
    }
    .ls-additional--info--clickable-label {
      font-size: var(--theme-txt-body-sm);
    }
    .ls-additional--info--content {
      background-color: $theme-color-primary-light;
    }
  }
}
</style>
